import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';


import InvoiceDialog from './InvoiceDialog';

const CashierTransactionsDialog = ({ open, onClose, transactions, loading, cashierName }) => {
  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [selectedSale, setSelectedSale] = useState(null);

  const handleInvoiceClick = (sale) => {
    setSelectedSale(sale);
    setInvoiceOpen(true);
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Transactions for {cashierName}</DialogTitle>
        <DialogContent>
          {loading ? (
            <CircularProgress />
          ) : transactions.length === 0 ? (
            <Typography>No transactions found.</Typography>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Invoice #</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell align="right">Total</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactions.map((tx) => (
                    <TableRow key={tx._id}>
                      <TableCell>
                        <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={() => handleInvoiceClick(tx)}
                        >
                          {tx._id.slice(-6).toUpperCase()}
                        </span>
                      </TableCell>
                      <TableCell>{new Date(tx.createdAt).toLocaleString()}</TableCell>
                      <TableCell>{tx.customer?.name || '-'}</TableCell>
                      <TableCell align="right">{tx.total.toLocaleString(undefined, { style: 'currency', currency: 'LKR' })}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
      <InvoiceDialog open={invoiceOpen} onClose={() => setInvoiceOpen(false)} sale={selectedSale} />
    </>
  );
};

export default CashierTransactionsDialog;
